<div class="details-header flex justify-content-between align-items-center mt-2">
  <div class="flex gap-2 align-items-center">
    <button class="secondary-button p-0 mr-2" (click)="closeDialog()" data-clarity-unmask="true">
      X
    </button>
    <button class="semiround-button" (click)="moveUp()" data-clarity-unmask="true">
      <i class="pi pi-angle-up"></i>
    </button>
    <button class="semiround-button" (click)="moveDown()" data-clarity-unmask="true">
      <i class="pi pi-angle-down"></i>
    </button>
    {{ currentUserIndex + 1 }} z {{ data.usersListPerPage.length }} wyników
  </div>
  <div class="text-sm text-bluegray-500">Data utworzenia: {{currentUser.created | date: 'dd.MM.yyyy'}}</div>
</div>
<div class="flex flex-wrap sm:flex-nowrap justify-content-between  mt-5 mb-3">
  <div class="flex flex-column gap-2">
    <p class="text-sm text-bluegray-500">Ostatnie logowanie: {{currentUser.lastLoginDate | date: 'dd.MM.yyyy'}}</p>
    <p *ngIf="devices[0]" class="text-sm text-bluegray-500">Ostatnie urządzenie: {{ devices[0].device.description }}</p>
    <div class="flex justify-content-between">
      <p class="font-semibold text-xl">{{ currentUser.displayName }} <span class="text-sm font-normal">(ID {{currentUser.guid.slice(-6)}})</span></p>
    </div>
  </div>
  <div>
    <p-button label="Przydziel abonament" icon="pi pi-briefcase" (click)="openAssignSubscription()" data-clarity-unmask="true" />
  </div>
</div>
<p-tabView (onChange)="handleTabSwitch($event)" [activeIndex]="selectedTabIndex">
  <p-tabPanel header="Dane podstawowe">
      <div class="flex flex-wrap justify-content-between ">
        <ng-container *ngFor="let field of usedDetailsViewFields">
          <div [ngSwitch]="field.type" class="w-full flex-wrap sm:flex-nowrap flex border-bottom-1 border-bluegray-300"
            [ngStyle]="{ 'padding-block': '12px', 'min-height': '64px' }"
            [ngClass]="field.fieldWidth ? field.fieldWidth : 'lg:w-26rem'">
            <label [for]="field.name" class="flex-none flex align-items-center text-gray-500 font-normal text-sm"
              [ngClass]="field.labelWidth ? field.labelWidth : 'w-10rem'">
              <span class="text-sm">{{ field.label }}<i *ngIf="field.fieldTooltip" class="pi pi-info-circle ml-2"
                  [pTooltip]="field.fieldTooltip" tooltipPosition="bottom"></i></span>
            </label>
            <div class="w-full flex flex-wrap md:flex-nowrap justify-content-between align-items-center gap-2">
              <p>{{ field.type === 'calendar' ? (currentUser[field.name] | date: 'dd.MM.yyyy' ): field.name === 'guid' ? currentUser[field.name].slice(-6) : currentUser[field.name] }}</p>
              <div *ngIf="field.name === 'email'" class="flex flex-wrap justify-content-end align-items-center gap-3">
                <span *ngIf="currentUser.emailConfirmed" class="email-state email-confirmed">
                  <i class="pi pi-check-circle" aria-hidden="true"></i> Potwierdzony
                </span>
                <ng-container *ngIf="currentUser.emailConfirmed === false">
                  <span class="email-state email-unconfirmed">
                    <i class="pi pi-clock" aria-hidden="true"></i> Niepotwierdzony
                  </span>
                  <p-button label="Potwierdź e-mail" icon="pi pi-check"
                    [loading]="emailConfirmationPending.has(currentUser.guid)" (onClick)="confirmEmail()" data-clarity-unmask="true"/>
                  <p-button label="Wyślij link" icon="pi pi-envelope" [outlined]="true" ariaLabel="Wyślij link aktywacyjny ponownie"
                    pTooltip="Wyślij link aktywacyjny ponownie" tooltipPosition="bottom"
                    [loading]="activationLinkPending.has(currentUser.guid)" (onClick)="resendActivationLink()" data-clarity-unmask="true"/>
                </ng-container>
              </div>
            </div>

          </div>
        </ng-container>
      </div>
    <div class="flex flex-wrap justify-content-between ">
        <div class="w-full flex-wrap sm:flex-nowrap flex border-bottom-1 border-bluegray-300" [ngStyle]="{ 'padding-block': '12px', 'min-height': '64px' }">
          <label for="userOsk" class="flex-none flex align-items-center text-gray-500 font-normal text-sm w-10rem">OSK</label>
          <div *ngIf="!oskEditing; else oskEditor" class="w-full flex flex-wrap md:flex-nowrap justify-content-between align-items-center gap-2">
            <p *ngIf="userOskLoading" class="text-bluegray-500">Wczytywanie…</p>
            <p *ngIf="userOskError" class="text-red-600">{{ userOskError }}</p>
            <ng-container *ngIf="userOsk && !userOskLoading">
              <p *ngIf="userOsk.oskCompanyGuid; else noOsk" class="user-osk">
                {{ userOsk.oskName || 'OSK bez nazwy' }}
                <span *ngIf="userOskDetails" class="text-sm text-bluegray-500">({{ userOskDetails }})</span>
              </p>
              <ng-template #noOsk><p class="text-bluegray-500">Brak przypisania do OSK</p></ng-template>
              <div class="md:min-w-max flex align-items-center gap-2">
                <p-button *ngIf="userOsk.canBeAssigned" icon="pi pi-building"
                  [label]="userOsk.oskCompanyGuid ? 'Zmień OSK' : 'Przypisz do OSK'" (onClick)="startOskEdit()" data-clarity-unmask="true"/>
                <span *ngIf="!userOsk.canBeAssigned" class="text-sm text-bluegray-500"
                  pTooltip="Konto ma rolę na platformie (np. OSK lub operatora), więc nie może być kursantem OSK."
                  tooltipPosition="left">
                  <i class="pi pi-lock" aria-hidden="true"></i> Konto z rolą na platformie
                </span>
                <p-button *ngIf="userOsk.oskCompanyGuid" label="Odepnij" icon="pi pi-times" severity="secondary"
                  [outlined]="true" [loading]="oskSaving" (onClick)="detachOsk()" data-clarity-unmask="true"/>
              </div>
            </ng-container>
          </div>
          <ng-template #oskEditor>
            <div class="w-full flex flex-wrap md:flex-nowrap justify-content-between align-items-center gap-2">
              <p-autoComplete class="osk-search" styleClass="w-full" inputStyleClass="w-full" inputId="userOsk"
                [(ngModel)]="oskSelection" [suggestions]="oskSuggestions" (completeMethod)="searchOsks($event)"
                field="oskName" optionLabel="oskName" [dropdown]="true" [forceSelection]="true" appendTo="body"
                placeholder="Wyszukaj po nazwie, kodzie, mieście lub NIP" emptyMessage="Nie znaleziono OSK">
                <ng-template let-osk pTemplate="item">
                  <div class="flex flex-column">
                    <span>{{ osk.oskName }}</span>
                    <small class="text-bluegray-500">{{ osk.oskShortCode }}<ng-container *ngIf="osk.oskCity">, {{ osk.oskCity }}</ng-container></small>
                  </div>
                </ng-template>
              </p-autoComplete>
              <div class="md:min-w-max flex align-items-center gap-2">
                <p-button label="Przypisz" icon="pi pi-check" [loading]="oskSaving"
                  [disabled]="!selectedOsk || selectedOsk.guid === userOsk?.oskCompanyGuid" (onClick)="assignOsk()" data-clarity-unmask="true"/>
                <p-button label="Anuluj" [link]="true" (onClick)="cancelOskEdit()" data-clarity-unmask="true"/>
              </div>
            </div>
          </ng-template>
        </div>
    </div>
    <div class="flex flex-wrap justify-content-between ">
        <div class="w-full flex-wrap sm:flex-nowrap flex border-bottom-1 border-bluegray-300" [ngStyle]="{ 'padding-block': '12px', 'min-height': '64px' }">
          <label for="password" class="flex-none flex align-items-center text-gray-500 font-normal text-sm w-10rem">Hasło</label>
          <div class="w-full flex flex-wrap md:flex-nowrap justify-content-between align-items-center gap-2">
            <p>*****************</p>
            <div class="md:min-w-max">
              <p-button label="Reset hasła" icon="pi pi-key" pTooltip="Wygeneruj nowe hasło i wyślij je użytkownikowi e-mailem"
                tooltipPosition="left" [loading]="passwordResetPending.has(currentUser.guid)" (onClick)="resetPassword()" data-clarity-unmask="true"/>
            </div>
          </div>
        </div>
    </div>

    <section class="mt-6 flex justify-content-between ">
      <div class="login-as flex gap-3">
        <p-button severity="secondary" label="Zaloguj jako użytkownik"
          (onClick)="logAsCurrentUser('Userserviceurl')" data-clarity-unmask="true"></p-button>
        <p-button severity="secondary" label="Zaloguj jako partner"
          (onClick)="logAsCurrentUser('Admserviceurl')" data-clarity-unmask="true"></p-button>
      </div>
    </section>

  </p-tabPanel>
  <p-tabPanel header="Abonamenty">
    <p-table [value]="currentUserSubscriptionRows" [rows]="10" [paginator]="false" dataKey="guid"
      [showCurrentPageReport]="false" styleClass="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>Nazwa</th>
          <th>Status</th>
          <th>Data wygaśnięcia</th>
          <th>Akcje</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr class="headlight">
          <td>Pakiet {{ user.subscriptionPlan }}</td>
          <td>
            <div class="subscription-type" [style.background-color]="subscriptionState.color">
              {{ subscriptionState.label }}
            </div>
          </td>
          <td>
            {{ (user.subscriptionPlanActiveTo | date: 'dd.MM.yyyy HH:mm') || '–' }}
          </td>
          <td>
            <div class="flex flex-wrap gap-2">
              <button class="primary-button" (click)="openAssignSubscription()" data-clarity-unmask="true">
                <i class="pi pi-briefcase"></i>
                Przydziel / przedłuż
              </button>
              <button class="primary-button" (click)="openAssignSubscription('validTo')" data-clarity-unmask="true">
                <i class="pi pi-calendar"></i>
                Zmień datę
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">
            <div class="flex align-items-center justify-content-between gap-3 py-3">
              <span class="text-bluegray-500">Ten użytkownik nie ma przydzielonego abonamentu.</span>
              <p-button label="Przydziel abonament" icon="pi pi-briefcase" (onClick)="openAssignSubscription()" data-clarity-unmask="true" />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
  <p-tabPanel header="Urządzenia">
    <p *ngIf="devicesError" class="text-red-600 mb-3">{{ devicesError }}</p>
    <p-table [value]="devices" [loading]="devicesLoading" dataKey="id" styleClass="p-datatable-sm p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>Urządzenie</th>
          <th>Ostatnio aktywne</th>
          <th>Ostatnie logowanie</th>
          <th>Logowania</th>
          <th>Pierwsze użycie</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-userDevice>
        <tr>
          <td><app-client-device [device]="userDevice.device" /></td>
          <td class="white-space-nowrap">{{ userDevice.lastSeen | date: 'dd.MM.yyyy HH:mm' }}</td>
          <td class="white-space-nowrap">{{ (userDevice.lastLogin | date: 'dd.MM.yyyy HH:mm') || '–' }}</td>
          <td>{{ userDevice.loginCount }}</td>
          <td class="white-space-nowrap">{{ userDevice.firstSeen | date: 'dd.MM.yyyy' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-bluegray-500 py-3">
            Brak danych o urządzeniach. Pojawią się, gdy użytkownik zaloguje się lub skorzysta z wersji aplikacji,
            która je przesyła.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
  <p-tabPanel header="Uprawnienia">
    <div class="flex mt-5">
      <div class="flex flex-column gap-2">
        <div class="field-checkbox">
          <p-checkbox [(ngModel)]="permisions" label="Administrator" name="permisions" value="Administrator" />
        </div>
        <div class="field-checkbox">
          <p-checkbox [(ngModel)]="permisions" label="Koordynator" name="permisions" value="Koordynator" />
        </div>
        <div class="field-checkbox">
          <p-checkbox [(ngModel)]="permisions" label="Użytkownik" name="permisions" value="Użytkownik" />
        </div>
        <div class="field-checkbox">
          <p-checkbox [(ngModel)]="permisions" label="Only view" name="permisions" value="Only view" />
        </div>
        <div class="field-checkbox">
          <p-checkbox [(ngModel)]="permisions" label="Tester" name="permisions" value="Tester" />
        </div>
      </div>
    </div>
  </p-tabPanel>
  <p-tabPanel header="Transakcje">
    <!-- <fas-services-table
          [value]="usersList"
          [columns]="transColumns"
          [rows]="10"
          [paginator]="true"
          [globalFilterFields]="['userName', 'creationDate']"
          [selection]="transSelected"
          dataKey="userName"
          [showCheckbox]="true"
        >
        </fas-services-table> -->
  </p-tabPanel>
</p-tabView>

<div *ngIf="selectedTabIndex === 0" class="flex align-items-center justify-content-between">
  <div *ngIf="isEditMode" class="flex gap-2">
    <!-- <p-button label="Zapisz zmiany" icon="pi pi-save" /> -->
    <!-- <p-button class="link-btn" label="Anuluj" [link]="true" (onClick)="setEditMode()" /> -->
  </div>
  <!-- <div *ngIf="!isEditMode">
    <p-button label="Edytuj użytkownika" icon="pi pi-pencil" (onClick)="setEditMode()" />
  </div> -->
</div>
<p-button label="Wystaw fakturę zbiorczą" [disabled]="true" *ngIf="selectedTabIndex === 4" class="primary-button" data-clarity-unmask="true" />
<p-confirmDialog key="platformUserAccountAction" appendTo="body" [style]="{ width: '480px' }"></p-confirmDialog>